import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { Card } from '@atlaskit/media-card';
import { FilmstripView } from '@atlaskit/media-filmstrip';
import { sortFilesYoungestFirstOnLeft } from '../../utils';
import { defaultImageCardDimensions } from './constants';
export var AttachmentSharedFilmstrip = function AttachmentSharedFilmstrip(props) {
  var viewableFiles = props.viewableFiles,
    enableDownloadButton = props.enableDownloadButton;
  var _useState = useState({
      animate: false,
      offset: 0
    }),
    _useState2 = _slicedToArray(_useState, 2),
    animateAndOffset = _useState2[0],
    setAnimateAndOffset = _useState2[1];
  var animate = animateAndOffset.animate,
    offset = animateAndOffset.offset;
  var onScroll = function onScroll(e) {
    setAnimateAndOffset({
      animate: e.animate,
      offset: e.offset
    });
  };
  return /*#__PURE__*/React.createElement(FilmstripView, {
    onScroll: onScroll,
    animate: animate,
    offset: offset
  }, viewableFiles.sort(function (a, b) {
    return sortFilesYoungestFirstOnLeft(a, b);
  }).map(function (file) {
    return /*#__PURE__*/React.createElement("div", {
      "data-testid": "proforma-attachment-field-card",
      key: file.identifier.id.toString()
    }, /*#__PURE__*/React.createElement(Card, {
      key: file.identifier.id.toString(),
      mediaClientConfig: file.mediaClientConfig,
      identifier: file.identifier
      // @ts-expect-error - TS2322 - Type 'CardAction[]' is not assignable to type 'import("/buildeng/bamboo-agent-home/xml-data/build-dir/JF-TSMIG123-APPLY/node_modules/@atlaskit/media-card/dist/types/actions").CardAction[]'.
      ,
      actions: file.actions,
      shouldOpenMediaViewer: true,
      shouldEnableDownloadButton: enableDownloadButton,
      dimensions: defaultImageCardDimensions
    }));
  }));
};